import { ThemeOptions } from '@mui/material/styles';

import { clubCardStyleOverrides } from './cardStyles';

export const acgColors = {
  primary: '#057ea3',
  primaryShade: '#0083a9',
  primaryTint: '#99bdc7',
  primaryContrast: '#ffffff',
  backgroundContent: '#ededed',
} as const;

const acgThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: acgColors.primary,
      dark: acgColors.primaryShade,
      light: acgColors.primaryTint,
      contrastText: acgColors.primaryContrast,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: clubCardStyleOverrides({
          accentImage: 'linear-gradient(#377d9f, #377d9f)',
          legacyAccent: '#377d9f',
        }),
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: acgColors.primary,
          '&:focus': {
            color: acgColors.primaryShade,
            outline: `solid 2px ${acgColors.primaryShade}`,
          },
          '&:hover': { color: acgColors.primaryShade },
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            backgroundColor: acgColors.primary,
            '&:focus': {
              border: `1px solid ${acgColors.primaryShade}`,
              backgroundColor: acgColors.primaryShade,
              outline: `solid 2px ${acgColors.primaryShade}`,
              outlineOffset: '1px',
            },
            '&:hover': { backgroundColor: acgColors.primaryShade },
          },
        },
        {
          props: { variant: 'text' },
          style: {
            '&:focus': {
              color: acgColors.primaryShade,
              outline: `solid 2px ${acgColors.primaryShade}`,
              outlineOffset: '1px',
            },
          },
        },
      ],
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          '.MuiSwitch-switchBase.Mui-checked:hover': {
            backgroundColor: `${acgColors.primary}1A`,
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: { '&:focus': { outline: `solid 2px ${acgColors.primaryShade}` } },
      },
    },
  },
};

export default acgThemeOptions;
